/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class GoalRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let store = this.store;
    let person = this.modelFor('people.person').person;

    return hash({
      person,
      goal: store.findRecord('goals/goal', params.goal_id),
      states: store.query('goals/state', {
        personId: person.id,
        goalId: params.goal_id,
        current: true,
      }),
      posts: store.query('posts/post', {
        personId: person.id,
        goalId: params.goal_id,
        include: 'reactions,comments',
      }),
    });
  }
}
